/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadsetAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.992 2c1.316 0 2.618.262 3.833.77a10.006 10.006 0 0 1 3.247 2.194 10.119 10.119 0 0 1 2.167 3.28C21.736 9.456 22 10.661 22 12v9h-5.277l-3.753-2.252A2 2 0 1 1 14 17l-.002.032L16 18.233V14h4v-2c0-1.054-.203-2.003-.611-2.999a8.114 8.114 0 0 0-1.739-2.63 8.004 8.004 0 0 0-2.597-1.756 7.923 7.923 0 0 0-6.121 0 8.004 8.004 0 0 0-2.598 1.756 8.114 8.114 0 0 0-1.738 2.63A7.65 7.65 0 0 0 4 12v2h4v7H2v-9c0-1.329.244-2.534.745-3.757a10.117 10.117 0 0 1 2.167-3.28A10.004 10.004 0 0 1 8.16 2.772 9.923 9.923 0 0 1 11.992 2zM4 19h2v-3H4zm14 0h2v-3h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeadsetAlt as HeadsetAlt };
